import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazySpaceDirectory: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceDirectory" */ '../src/SpaceDirectory.tsx'))
			.SpaceDirectory,
});
